// extracted by mini-css-extract-plugin
export default {"container":"Notfound_container__Astv4","container_base":"Notfound_container_base__KtNKF","title":"Notfound_title__sd5wT"};